import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Icon } from '@iconify/react'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import { BrandHeader, BuildStrip, IconButton, ThemeModeToggle, useAuth } from '@jupi/ui'

// Navy bar with the JuPi mark, the page's own back button where there is
// somewhere to go back to, and sign-out. One column, centred, and wide enough
// to fill an iPad in portrait without stretching across a landscape one.
export default function Layout() {
  const { t } = useTranslation()
  const { user, logout } = useAuth()
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const atRoot = pathname === '/'

  return (
    <Box sx={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column', bgcolor: 'background.default' }}>
      <BuildStrip />
      <AppBar position="sticky" color="primary" sx={{ bgcolor: 'primary.dark', pt: 'env(safe-area-inset-top)' }}>
        <Toolbar sx={{ minHeight: 72, gap: 1.5 }}>
          {atRoot ? null : (
            <IconButton color="inherit" edge="start" aria-label={t('huolto.back')} onClick={() => navigate(-1)}>
              <Icon icon="mdi:arrow-left" width={32} />
            </IconButton>
          )}
          <BrandHeader label={t('huolto.appLabel')} compact />
          <Box sx={{ flexGrow: 1 }} />
          <Typography noWrap sx={{ display: { xs: 'none', sm: 'block' }, maxWidth: 220, opacity: 0.85 }}>
            {user?.displayName}
          </Typography>
          <ThemeModeToggle />
          <IconButton color="inherit" aria-label={t('huolto.signOut')} onClick={() => void logout()}>
            <Icon icon="mdi:logout" width={28} />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Container maxWidth="md" sx={{ flexGrow: 1, py: 3, px: { xs: 2, sm: 3 }, pb: 'calc(24px + env(safe-area-inset-bottom))' }}>
        <Outlet />
      </Container>
    </Box>
  )
}
